import z from "zod";
import { ResellerIdScheme } from "../ids";
import { MoneyScheme } from "../money";

export const VivaIsvFeeScheme = z.object({
  percentage: z.number(),
  amount: MoneyScheme,
});

export const RestGetVivaIsvConfig = z.object({
  isvClientId: z.string(),
  isvClientSecret: z.string(),
  isvSourceCode: ResellerIdScheme.nullable(),
  merchantId: z.string(),
  isvFee: VivaIsvFeeScheme.nullable(),
});

export type RestGetVivaIsvConfig = z.infer<typeof RestGetVivaIsvConfig>;
